// 公用接口
import { get, post, postv3 } from '~/assets/js/api/methods'

import apiList from '~/api.config.js'
// 只允许客户端
const { ipTranslet, testwikidatacenter, homeClient } = apiList

export default (axios) => ({
  // 获取用户真实ip和ip所在国家(geoip)
  GetUserIpAndCountry: (params = {}) => get(axios, `${ipTranslet}/ip`, params),
  // 获取用户真实ip和ip所在国家(ip138)
  GetIp138: (params = {}) => get(axios, `${ipTranslet}/ip138/getcity`, params),
  // 人机校验
  CheckRobot: (params = {}) => get(axios, `${homeClient}/wikifxweb-v1/usercenter/other/checkauto-v1`, params),
  // 通用v3版接口
  GetDataV3: (params = {}, headers = {}) => post(axios, `${testwikidatacenter}/wikifxweb-v1/invoke-v3/v3`, params, false, headers), // 通用V3版本
  // 通用v3版接口[服务端post]
  V3: (params = {}, headers = {}) => postv3(axios, `${testwikidatacenter}/wikifxweb-v1/invoke-v3/v3`, params, false, headers), // V3版本
  // 通用v3版接口[客户端post]
  CV3: (params = {}, headers = {}) => postv3(axios, `${homeClient}/wikifxweb-v1/invoke-v3/v3`, params, false, headers)
})
